import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pickupAddress: null,
  dropoffAddress: null,
  addresses: [], // all user addresses
};

const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    setAddresses: (state, action) => {
      state.addresses = action.payload || [];

      // Ensure pickup/dropoff addresses are still valid
      if (state.pickupAddress) {
        const exists = state.addresses.find(
          (addr) => (addr.id || addr.address_id) === (state.pickupAddress.id || state.pickupAddress.address_id)
        );
        if (!exists) state.pickupAddress = null;
      }

      if (state.dropoffAddress) {
        const exists = state.addresses.find(
          (addr) => (addr.id || addr.address_id) === (state.dropoffAddress.id || state.dropoffAddress.address_id)
        );
        if (!exists) state.dropoffAddress = null;
      }
    },

    setPickupAddress: (state, action) => {
      state.pickupAddress = action.payload || null;

      // Prevent pickup and dropoff being the same
      if (state.dropoffAddress) {
        const pickupId = state.pickupAddress?.id || state.pickupAddress?.address_id;
        const dropoffId = state.dropoffAddress?.id || state.dropoffAddress?.address_id;
        if (pickupId && pickupId === dropoffId) {
          state.dropoffAddress = null;
        }
      }
    },

    setDropoffAddress: (state, action) => {
      state.dropoffAddress = action.payload || null;

      // Prevent dropoff and pickup being the same
      if (state.pickupAddress) {
        const dropoffId = state.dropoffAddress?.id || state.dropoffAddress?.address_id;
        const pickupId = state.pickupAddress?.id || state.pickupAddress?.address_id;
        if (dropoffId && dropoffId === pickupId) {
          state.pickupAddress = null;
        }
      }
    },

    resetAddresses: () => initialState,
    clearPickupDropoff: () => initialState,
  },
});

export const { setAddresses, setPickupAddress, setDropoffAddress, resetAddresses, clearPickupDropoff } =
  addressSlice.actions;

export default addressSlice.reducer;
